exports = module.exports = require("../../../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*---------------------------------------------------------------------------------------------\n *  Copyright (c) Microsoft Corporation. All rights reserved.\n *  Licensed under the MIT License. See License.txt in the project root for license information.\n *--------------------------------------------------------------------------------------------*/\n\n.monaco-count-badge {\n\tpadding: 0.3em 0.5em;\n\tborder-radius: 1em;\n\tfont-size: 85%;\n\tmin-width: 1.6em;\n\tline-height: 1em;\n\tfont-weight: normal;\n\ttext-align: center;\n\tdisplay: inline-block;\n\tbox-sizing: border-box;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/monaco-editor-core/esm/vs/base/browser/ui/countBadge/countBadge.css
// module id = 435
// module chunks = 0